import { Injectable } from '@angular/core';
import { createClient, Entry } from 'contentful';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class ContentfulService {
  private contentfulClient = createClient({
    space: environment.contentful.space,
    environment: environment.contentful.environment,
    accessToken: environment.contentful.accessToken,
  });

  constructor() {}

  // Load the open letter entry from contentful, based on the entry id specified during intilization
  getLetter(): Promise<Entry<any>> {
    return this.contentfulClient
      .getEntries({ 'sys.id': '4ePLxRm2eWenfIfsupyFPT', include: 1 })
      .then((res) => res.items[0]);
  }

  getImpressum(): Promise<Entry<any>> {
    return this.contentfulClient
      .getEntries({ 'sys.id': 'fhSBVTEzPuRruN9rY37f8', include: 1 })
      .then((res) => res.items[0]);
  }

  getDataprivacy(): Promise<Entry<any>> {
    return this.contentfulClient
      .getEntries({ 'sys.id': '5ojjAAp1E9rhQHEz6BGyFP', include: 1 })
      .then((res) => res.items[0]);
  }

  // getProgressbar(): Promise<Entry<any>> {
  //   return this.contentfulClient
  //     .getEntries({ 'sys.id': '576DSiP37ftSEVUxZoU9yR' })
  //     .then((res) => res.items[0]);
  // }
}
